/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeletePartnerNumber$Params {
  partnerNumberId: number;
  customerBaseId: number;
}

export function deletePartnerNumber(http: HttpClient, rootUrl: string, params: DeletePartnerNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deletePartnerNumber.PATH, 'delete');
  if (params) {
    rb.path('partnerNumberId', params.partnerNumberId, {});
    rb.query('customerBaseId', params.customerBaseId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deletePartnerNumber.PATH = '/partnerNumber/{partnerNumberId}';
